import auth from '@/config/auth.json'
function formartAuth(auths, codes = {}) {
  if (auths.length > 0) {
    auths.map(item => {
      if (!codes[item.name_en]) {
        codes[item.name_en] = { pAuthCode: item.codes[0], mAuthCode: item.codes[1], platform: item.platform ? item.platform : 0 }
      }
      if (item.children) {
        formartAuth(item.children, codes)
      }
    })
  }
  return codes
}

var authCode = formartAuth(auth)
export default authCode